.EmptyContainer
    display: flex
    flex-direction: column
    align-items: center
    margin: 0
    padding: 0
    font-size: 12px
    color: rgb($globalSettingsFontPrimary)
    background-color: rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box
p
    margin: 0
    padding: 0
.EmptyTitle
    font-weight: 700
